import React from "react";
// import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withStyles from "@material-ui/core/styles/withStyles";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";

import SectionPills from "./Sections/SectionPills.jsx";
import FooterSection from "../LandingPage/Sections/FooterSection";

import blogPostsPageStyle from "../../assets/jss/material-kit-pro-react/views/360CatalogPageStyle";

class Catalog360Page extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Contenido 360 | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/contenido-360" />
                    <meta name="description" content="Conoce espectaculares lugares a través de contenido inmersivo en 360 grados" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info" />}
                    changeColorOnScroll={{
                        height: 100,
                        color: "white"
                    }}
                />
                <Parallax image={require("../../assets/img/landing-bg.jpg")} filter="dark" small>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
                                <h1 className={classes.title}>
                                    Experiencia en 360°
                                </h1>
                                <h4 className={classes.subtitle}>Conoce los sitios de interés a partir de una experiencia inmersiva</h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classes.main}>
                    <div className={classes.container}>
                        <SectionPills />
                    </div>
                </div>

                <FooterSection />
            </div>
        );
    }
}

export default withStyles(blogPostsPageStyle)(Catalog360Page);



// WEBPACK FOOTER //
// ./src/views/360CatalogPage/360CatalogPage.js